<template>
  <w-icon-wrapper
    :width='24.75'
    :height='24'
    view-box='0 0 24.75 24'
    icon-name='work-car-icon'
  >
    <g
      id="_70_Car_Icon"
      data-name="70 Car_Icon"
      transform="translate(-1026 -523)"
    >
      <g
        id="Gruppe_25446"
        data-name="Gruppe 25446"
        transform="translate(1026.996 525)"
      >
        <path
          id="Pfad_55787"
          data-name="Pfad 55787"
          d="M21.44,9.78l-1-1,.76-.38a1,1,0,1,0-.9-1.78l-1,.49-1.11-3.2A3.66,3.66,0,0,0,14.72,1.5H8.78A3.65,3.65,0,0,0,5.31,3.91L4.19,7.1l-1-.49a1,1,0,1,0-.9,1.78l.76.38-1,1A5.3,5.3,0,0,0,.88,15.51l.66,1.65a2.12,2.12,0,0,0,2,1.34h.24v2a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-2h8v2a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-2H20a2.13,2.13,0,0,0,2-1.34l.66-1.65a5.3,5.3,0,0,0-1.22-5.73ZM7.2,4.57A1.65,1.65,0,0,1,8.78,3.5h5.94A1.65,1.65,0,0,1,16.3,4.57L17.67,8.5H5.83Zm13.56,10.2-.66,1.65a.12.12,0,0,1-.12.08H3.51a.13.13,0,0,1-.12-.08l-.66-1.65a3.33,3.33,0,0,1,.74-3.58l.69-.69H19.33l.7.7A3.28,3.28,0,0,1,20.76,14.77Z"
          transform="translate(-0.49 -1.5)"
          fill="currentColor"
        />
        <path
          id="Pfad_55788"
          data-name="Pfad 55788"
          d="M5.63,11.55c-.93-.05-1.37,1.68-1.16,1.94a3.88,3.88,0,0,0,2.64,1c.85-.13.45-.77.45-.77S6.56,11.6,5.63,11.55Z"
          transform="translate(-0.49 -1.5)"
          fill="currentColor"
        />
        <path
          id="Pfad_55789"
          data-name="Pfad 55789"
          d="M17.77,11.55c-.93,0-1.93,2.16-1.93,2.16s-.4.64.45.77a3.91,3.91,0,0,0,2.65-1C19.15,13.23,18.7,11.5,17.77,11.55Z"
          transform="translate(-0.49 -1.5)"
          fill="currentColor"
        />
      </g>
      <rect
        id="Rechteck_4032"
        data-name="Rechteck 4032"
        width="24.75"
        height="24"
        transform="translate(1026 523)"
        fill="none"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCar' };
</script>
